import { enc } from './core.js';
export function uploadsApi(c) {
    return {
        /** 503 `UPLOADS_NOT_CONFIGURED` si el servidor no tiene R2 configurado. */
        presign: (localId, body) => c.post(`/locals/${enc(localId)}/uploads/presign`, body),
    };
}
//# sourceMappingURL=uploads.js.map